import React from 'react';
import OrderStatus from './OrderStatus';
import { initReactApp } from 'shared/util/ApplicationInit';

const render = initReactApp(() => <OrderStatus />, 'order-status');

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./OrderStatus', () => {
		render();
	});
}
